"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEUROSITY_DATA_PROP = exports.NEUROSITY_SAMPLING_RATE = exports.NEUROSITY_EPOCH_INTERVAL = exports.NEUROSITY_EPOCH_DURATION = exports.NEORHYTHM_MEDITATION_CALM_SYNCHRONIZATION = exports.NEORHYTHM_MEDITATION_THETA = exports.NEORHYTHM_PAIN_CONTROL = exports.NEORHYTHM_IMPROVE_SLEEP = exports.NEORHYTHM_DEEP_RELAXATION = exports.NEORHYTHM_ENERGY_AND_VITALITY = exports.NEORHYTHM_ENHANCE_MENTAL_CAPACITY = exports.NEORHYTHM_SERVICE_UUID = exports.NEORHYTHM_CHARACTERISTIC = exports.NEORHYTHM_SERVICE_ID = exports.NEORHYTHM_SERVICE = exports.NEORHYTHM_NAME = exports.INSAI_ENHANCE_MENTAL_CAPACITY = exports.INSAI_STOP_STIMULATION = exports.INSAI_EEG_SCALING_FACTOR_WITHOUT_GAIN = exports.INSAI_VREF = exports.INSAI_MOTION_CHANNELS = exports.INSAI_PPG_CHANNELS = exports.INSAI_EEG_CHANNELS = exports.INSAI_MOTION_SAMPLING_RATE = exports.INSAI_PPG_SAMPLING_RATE = exports.INSAI_EEG_SAMPLING_RATE = exports.INSAI_STIMULATION_CHARACTERISTIC = exports.INSAI_MOTION_CHARACTERISTIC = exports.INSAI_CONTROL_CHARACTERISTIC = exports.INSAI_TX_CHARACTERISTIC = exports.INSAI_SERVICE = exports.INSAI_NAME = exports.MUSE_PPG_CHANNELS = exports.MUSE_EEG_CHANNELS = exports.MUSE_CHANNEL_NAMES = exports.MUSE_PPG_CHARACTERISTICS = exports.MUSE_PPG_SAMPLES_PER_READ = exports.MUSE_PPG_SAMPLING_RATE = exports.MUSE_GATT_ATTR_PPG3 = exports.MUSE_GATT_ATTR_PPG2 = exports.MUSE_GATT_ATTR_PPG1 = exports.MUSE_EEG_CHARACTERISTICS = exports.MUESE_EEG_SCALE_FACTOR = exports.MUSE_EEG_SAMPLES_PER_READ = exports.MUSE_EEG_SAMPLING_RATE = exports.MUSE_GATT_ATTR_RIGHTAUX = exports.MUSE_GATT_ATTR_TP10 = exports.MUSE_GATT_ATTR_AF8 = exports.MUSE_GATT_ATTR_AF7 = exports.MUSE_GATT_ATTR_TP9 = exports.MUSE_ACCELEROMETER_CHANNELS = exports.MUSE_ACCELEROMETER_SCALE_FACTOR = exports.MUSE_GATT_ATTR_ACCELEROMETER = exports.MUSE_ACCELEROMETER_SAMPLES_PER_READ = exports.MUSE_ACCELEROMETER_SAMPLING_RATE = exports.MUSE_GYRO_CHANNELS = exports.MUSE_GYRO_SCALE_FACTOR = exports.MUSE_GATT_ATTR_GYRO = exports.MUSE_GYRO_SAMPLES_PER_READ = exports.MUSE_GYRO_SAMPLING_RATE = exports.MUSE_GATT_ATTR_TELEMETRY = exports.MUSE_GATT_ATTR_STREAM_TOGGLE = exports.AUTO_DISCONNECT_DELAY = exports.MUSE_SCAN_TIMEOUT = exports.MUSE_SERVICE = void 0;
// Muse
exports.MUSE_SERVICE = 0xfe8d;
exports.MUSE_SCAN_TIMEOUT = 10.5;
exports.AUTO_DISCONNECT_DELAY = 3;
// Control
exports.MUSE_GATT_ATTR_STREAM_TOGGLE = '273e0001-4c4d-454d-96be-f03bac821358';
// Telemetry
exports.MUSE_GATT_ATTR_TELEMETRY = '273e000b-4c4d-454d-96be-f03bac821358';
// Gyro
exports.MUSE_GYRO_SAMPLING_RATE = 52;
exports.MUSE_GYRO_SAMPLES_PER_READ = 3;
exports.MUSE_GATT_ATTR_GYRO = '273e0009-4c4d-454d-96be-f03bac821358';
exports.MUSE_GYRO_SCALE_FACTOR = 0.0074768;
exports.MUSE_GYRO_CHANNELS = ['X', 'Y', 'Z'];
// Accel
exports.MUSE_ACCELEROMETER_SAMPLING_RATE = 52;
exports.MUSE_ACCELEROMETER_SAMPLES_PER_READ = 3;
exports.MUSE_GATT_ATTR_ACCELEROMETER = '273e000a-4c4d-454d-96be-f03bac821358';
exports.MUSE_ACCELEROMETER_SCALE_FACTOR = 0.0000610352;
exports.MUSE_ACCELEROMETER_CHANNELS = ['X', 'Y', 'Z'];
// EEG
exports.MUSE_GATT_ATTR_TP9 = '273e0003-4c4d-454d-96be-f03bac821358';
exports.MUSE_GATT_ATTR_AF7 = '273e0004-4c4d-454d-96be-f03bac821358';
exports.MUSE_GATT_ATTR_AF8 = '273e0005-4c4d-454d-96be-f03bac821358';
exports.MUSE_GATT_ATTR_TP10 = '273e0006-4c4d-454d-96be-f03bac821358';
exports.MUSE_GATT_ATTR_RIGHTAUX = '273e0007-4c4d-454d-96be-f03bac821358';
exports.MUSE_EEG_SAMPLING_RATE = 256;
exports.MUSE_EEG_SAMPLES_PER_READ = 12;
exports.MUESE_EEG_SCALE_FACTOR = 0.48828125; // 12 bits on a 2 mVpp range
exports.MUSE_EEG_CHARACTERISTICS = [exports.MUSE_GATT_ATTR_TP9, exports.MUSE_GATT_ATTR_AF7, exports.MUSE_GATT_ATTR_AF8, exports.MUSE_GATT_ATTR_TP10, exports.MUSE_GATT_ATTR_RIGHTAUX];
// PPG
exports.MUSE_GATT_ATTR_PPG1 = '273e000f-4c4d-454d-96be-f03bac821358';
exports.MUSE_GATT_ATTR_PPG2 = '273e0010-4c4d-454d-96be-f03bac821358';
exports.MUSE_GATT_ATTR_PPG3 = '273e0011-4c4d-454d-96be-f03bac821358';
exports.MUSE_PPG_SAMPLING_RATE = 64;
exports.MUSE_PPG_SAMPLES_PER_READ = 6;
exports.MUSE_PPG_CHARACTERISTICS = [exports.MUSE_GATT_ATTR_PPG1, exports.MUSE_GATT_ATTR_PPG2, exports.MUSE_GATT_ATTR_PPG3];
//Channel Names
exports.MUSE_CHANNEL_NAMES = ['TP9', 'AF7', 'AF8', 'TP10', 'AUX', 'Ambient', 'Infrared', 'Red'];
exports.MUSE_EEG_CHANNELS = exports.MUSE_CHANNEL_NAMES.slice(0, 5);
exports.MUSE_PPG_CHANNELS = exports.MUSE_CHANNEL_NAMES.slice(5, 8);
// Insai
exports.INSAI_NAME = 'Insai_TMS';
exports.INSAI_SERVICE = '6e400001-b5a3-f393-e0a9-e50e24dcca9e';
exports.INSAI_TX_CHARACTERISTIC = '6e400002-b5a3-f393-e0a9-e50e24dcca9e';
exports.INSAI_CONTROL_CHARACTERISTIC = '6e400003-b5a3-f393-e0a9-e50e24dcca9e';
exports.INSAI_MOTION_CHARACTERISTIC = '6e400004-b5a3-f393-e0a9-e50e24dcca9e';
exports.INSAI_STIMULATION_CHARACTERISTIC = '6e400009-b5a3-f393-e0a9-e50e24dcca9e';
//INSAI Monitoring
exports.INSAI_EEG_SAMPLING_RATE = 250;
exports.INSAI_PPG_SAMPLING_RATE = 32;
exports.INSAI_MOTION_SAMPLING_RATE = 32;
exports.INSAI_EEG_CHANNELS = ['TP9', 'FT7', 'AF7', 'FP1', 'FP2', 'AF8', 'FT8', 'TP10'];
exports.INSAI_PPG_CHANNELS = ['Infrared'];
exports.INSAI_MOTION_CHANNELS = ['X', 'Y', 'Z'];
exports.INSAI_VREF = 4.5;
exports.INSAI_EEG_SCALING_FACTOR_WITHOUT_GAIN = exports.INSAI_VREF / 8388608;
//INSAI Stimulation
exports.INSAI_STOP_STIMULATION = 0x00;
exports.INSAI_ENHANCE_MENTAL_CAPACITY = 0x02;
// NeoRhythm
exports.NEORHYTHM_NAME = 'NeoRhythm';
exports.NEORHYTHM_SERVICE = '14b70001-c2e6-11e8-a355-529269fb1459';
exports.NEORHYTHM_SERVICE_ID = 0x180a;
exports.NEORHYTHM_CHARACTERISTIC = '14b70002-c2e6-11e8-a355-529269fb1459';
exports.NEORHYTHM_SERVICE_UUID = '0000180a-0000-1000-8000-00805f9b34fb';
// Programs
exports.NEORHYTHM_ENHANCE_MENTAL_CAPACITY = 0; // 'ENHANCE_MENTAL_CAPACITY';
exports.NEORHYTHM_ENERGY_AND_VITALITY = 1; //'ENERGY_AND_VITALITY';
exports.NEORHYTHM_DEEP_RELAXATION = 2; //'DEEP_RELAXATION';
exports.NEORHYTHM_IMPROVE_SLEEP = 3; //'IMPROVE_SLEEP';
exports.NEORHYTHM_PAIN_CONTROL = 5; //'PAIN_CONTROL';
exports.NEORHYTHM_MEDITATION_THETA = 6; //'MEDITATION_THETA';
exports.NEORHYTHM_MEDITATION_CALM_SYNCHRONIZATION = 7; //'MEDITATION_CALM_SYNCHRONIZATION';
// Default Neurosity Parameters
exports.NEUROSITY_EPOCH_DURATION = 100;
exports.NEUROSITY_EPOCH_INTERVAL = 256;
exports.NEUROSITY_SAMPLING_RATE = 256;
exports.NEUROSITY_DATA_PROP = 'data';
//# sourceMappingURL=constants.js.map